export default function ibFormHelperFunc() {
  const itiFlagTitle = document.createElement('div');
  itiFlagTitle.className = "iti__title";

  const itiSelectedFlag = document.querySelector(".iti__selected-flag");

  if(itiSelectedFlag == null) {
    return;
  }
  itiFlagTitle.innerHTML = itiSelectedFlag && itiSelectedFlag.getAttribute("title").split(":")[0];
  var itiTitles = document.getElementsByClassName("iti__title");
  if (itiTitles.length == 0 && (itiFlagTitle.innerHTML != itiSelectedFlag.innerHTML)) {
    itiSelectedFlag && itiSelectedFlag.insertBefore(itiFlagTitle, itiSelectedFlag.firstChild);
  }

  const itiFlag = document.querySelector(".iti__flag");
  if(itiFlag) {
    itiFlag.style.display = "none";
  }

  const itiCountryNames = document.querySelectorAll('.iti__country-name');
  itiCountryNames.forEach(element => {
    if(document.documentElement.lang === 'zh') {
      if(element.innerHTML === 'Hong Kong (香港)') {
        element.innerHTML = 'Hong Kong, China (中国香港)'
      }

      if(element.innerHTML === 'Macau (澳門)') {
        element.innerHTML = 'Macao, China (中国澳门)';
      }

      if(element.innerHTML === 'Taiwan (台灣)') {
        element.innerHTML = 'Taiwan (中国台湾)';
      }
    }

    if(document.documentElement.lang === 'zh-tw') {
      if(element.innerHTML === 'Hong Kong (香港)') {
        element.innerHTML = 'Hong Kong, China (中國香港)';
      }

      if(element.innerHTML === 'Macau (澳門)') {
        element.innerHTML = 'Macao, China (中國澳門)';
      }

      if(element.innerHTML === 'Taiwan (台灣)') {
        element.innerHTML = 'Taiwan (台灣)';
      }
    }
  });

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "attributes") {
        if(itiSelectedFlag) {
          if(document.documentElement.lang === 'zh') {
            if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'China (中国)') {
              mutation.target.textContent = 'China (中国)';
            } else if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'Hong Kong (香港)') {
              mutation.target.textContent = 'Hong Kong, China (中国香港)';
            } else if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'Macau (澳門)') {
              mutation.target.textContent = 'Macao, China (中国澳门)';
            } else if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'Taiwan (台灣)') {
              mutation.target.textContent = 'Taiwan (中国台湾)';
            } else {
              mutation.target.textContent = itiSelectedFlag.getAttribute("title").split(":")[0];
            }
          } else if(document.documentElement.lang === 'zh-tw') {
            if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'China (中国)') {
              mutation.target.textContent = 'China (中國)';
            } else if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'Hong Kong (香港)') {
              mutation.target.textContent = 'Hong Kong, China (中國香港)';
            } else if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'Macau (澳門)') {
              mutation.target.textContent = 'Macao, China (中國澳門)';
            } else if(itiSelectedFlag.getAttribute("title").split(":")[0] === 'Taiwan (台灣)') {
              mutation.target.textContent = 'Taiwan (台灣)';
            } else {
              mutation.target.textContent = itiSelectedFlag.getAttribute("title").split(":")[0];
            }
          } else {
            mutation.target.textContent = itiSelectedFlag && itiSelectedFlag.getAttribute("title").split(":")[0];
          }
        }
      }
    });
  });

  observer.observe(itiSelectedFlag, { subtree: true, childList: true, attributes: true });

  let telephone_field = document.getElementsByClassName("webform-webform-telephone-international");

  for (let item of telephone_field) {
    item.addEventListener("click", function(event) {
      let flag_container = document.getElementsByClassName("iti__flag-container");

      for (let item of flag_container) {
        let flag_li = document.querySelector('[aria-selected="true"]');
        if (flag_li) {
          let county_code = flag_li.getElementsByClassName("iti__dial-code");
          for (let i of county_code) {
            event.target.value = i.textContent;
          }
        }
      }
    });

    item.addEventListener("focusout", (event) => {
      event.target.value = event.target.value.replace(/\s/g, "");
    });

  }
}
